import { UseFormReturn } from 'react-hook-form'

import { TokenWithBalance } from '@/domain/common/types'
import { Form } from '@/ui/atoms/form/Form'
import { AssetInputProps } from '@/ui/molecules/asset-input/AssetInput'
import { AssetSelectorWithInput } from '@/ui/organisms/asset-selector-with-input/AssetSelectorWithInput'

import { AssetInputSchema } from '../../logic/form'
import { FormFieldsForDialog, BalanceType } from '../../types'
import { DialogPanelTitle } from '../DialogPanelTitle'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
export interface DialogFormProps {
  selectorAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  variant?: AssetInputProps['variant']
  walletIconLabel?: string
  balanceType?: BalanceType
  displayBalance?: NormalizedUnitNumber
}

export function DialogForm({
  selectorAssets,
  assetsFields,
  form,
  variant,
  balanceType = 'wallet',
  walletIconLabel,
}: DialogFormProps) {
  const { selectedAsset, changeAsset, maxSelectedFieldName, maxValue, displayBalance } = assetsFields

  return (
    <Form {...form}>
      <DialogPanelTitle>Amount</DialogPanelTitle>
      <AssetSelectorWithInput
        balanceType={balanceType}
        displayBalance={displayBalance}
        fieldName="value"
        control={form.control}
        selectorAssets={selectorAssets}
        selectedAsset={selectedAsset}
        setSelectedAsset={changeAsset}
        maxValue={maxValue}
        maxSelectedFieldName={maxSelectedFieldName}
        showError
        variant={variant}
        walletIconLabel={walletIconLabel}
      />
    </Form>
  )
}
